import { render, staticRenderFns } from "./reviewbook.vue?vue&type=template&id=e2d5fc9e"
import script from "./reviewbook.vue?vue&type=script&lang=js"
export * from "./reviewbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports